import { type ReactNode, useLayoutEffect, useRef } from "react"
import { useLocation, useNavigationType } from "react-router-dom"
import { useBackButton } from "@/shared/hooks/use-back-button"
import { cn } from "@/shared/lib/utils"
import { BottomNavigation } from "./bottom-navigation"

const positions = new Map<string, number>()
export function Layout({ children }: { children: ReactNode }) {
	useBackButton()
	const location = useLocation()
	const navigationType = useNavigationType()
	const hideNavigation = location.pathname.startsWith("/post/")
	const previousPath = useRef("")
	useLayoutEffect(() => {
		const key = location.key
		if (navigationType === "POP") {
			const target = positions.get(key) ?? 0
			let tries = 0
			const restore = () => {
				window.scrollTo(0, target)
				return window.scrollY >= target - 1
			}
			restore()
			const timer = window.setInterval(() => {
				if (restore() || ++tries > 30) window.clearInterval(timer)
			}, 50)
			previousPath.current = location.pathname
			return () => {
				window.clearInterval(timer)
				positions.set(key, window.scrollY)
			}
		}
		if (previousPath.current !== location.pathname) window.scrollTo(0, 0)
		previousPath.current = location.pathname
		return () => {
			positions.set(key, window.scrollY)
		}
	}, [location.key, location.pathname, navigationType])
	return (
		<div className={cn("min-h-dvh bg-background", !hideNavigation && "pb-nav-safe")}>
			<main>{children}</main>
			{!hideNavigation && <BottomNavigation />}
		</div>
	)
}
